import { defa }              from 'defa-object';
import Controller            from 'scripts/poppet/controller';
import SubscriptionContainer from 'scripts/defa/subscriptions/view-subscription-container';

/**
 * defa.controllers.SubscriptionController
 * The controller for the SubscriptionRouter
 * @version 1.3.0
 */
const channelLayout = Bb.Radio.channel( 'layout' ),
	  channelNav    = Bb.Radio.channel( 'nav' ),
	  channelUser   = Bb.Radio.channel( 'user' );

const SubscriptionController = Controller.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	/**
	 * Landing route for: subscriptions/:id(/)
	 * @param {Number} id  The id of the subscription to show.
	 * @void
	 */
	showSubscription: function ( id ) {
		
		this.requireSubscription( {
			view          : 'subscription:panel',
			callback      : this.attachSubscriptionContainer,
			subscriptionId: id,
		} );
		
	},
	
	/**
	 * Landing route for: subscriptions/:id/terminate(/)
	 * @param {Number} id  The id of the subscription to show.
	 * @void
	 */
	showSubscriptionTerminate: function ( id ) {
		
		this.requireSubscription( {
			view          : 'subscription:terminate',
			callback      : this.attachSubscriptionContainer,
			subscriptionId: id,
			closeLink     : {
				event : 'subscription:panel',
				params: [ id, ],
			},
		} );
		
	},
	
	/**
	 * Landing route for: subscriptions/:id/transfer(/)
	 * @param {Number} id  The id of the subscription to show.
	 * @void
	 */
	showSubscriptionTransfer: function ( id ) {
		
		this.requireSubscription( {
			view          : 'subscription:transfer',
			callback      : this.attachSubscriptionContainer,
			subscriptionId: id,
			closeLink     : {
				event : 'subscription:panel',
				params: [ id, ],
			},
		} );
	},
	
	/**
	 * Landing route for subscriptions/:id/replace(/)
	 * @param {number} id  The id of the subscription to change.
	 * @void
	 */
	showSubscriptionReplace: function ( id ) {
		
		this.requireSubscription( {
			view          : 'subscription:replace',
			callback      : this.attachSubscriptionContainer,
			subscriptionId: id,
			closeLink     : {
				event : 'subscription:panel',
				params: [ id, ],
			}
		} );
	},
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Requests a Subscription, before calling the callback.
	 * @param {Object} options All the needed options, most importantly a subscriptionId and a callback function.
	 * @void
	 */
	requireSubscription: function ( options ) {
		this.requireModel( 'Subscription', defa.models, options );
	},
	
	/**
	 * Create and display a SubscriptionContainer.
	 * @param {Object} options  An object containing all the needed objects for creating, listing and editing
	 *     Unit-information.
	 * @void
	 */
	attachSubscriptionContainer: function ( options ) {
		
		options           = options || {};
		options.user      = options.user || channelUser.request( 'model' );
		options.noLogin   = options.noLogin || false;
		options.closeLink = options.closeLink || {
			event : 'unit:control:settings',
			params: [ options.subscription.get( 'unit' ), ],
		};
		
		// if user isn't logged in, and this view isn't a no-login view, route to search.
		if ( channelUser.request( 'is:logged:out' ) && !options.noLogin ) {
			channelNav.trigger( 'user:login', { trigger: true, replace: true, } );
			
			
			// if the user is logged in, play with the subscriptionContainer.
		} else {
			
			let self = options.self || this;
			
			// if the SubscriptionContainer isn't made or is destroyed, create it and attach it's listeners
			if ( !( self.subscriptionContainer instanceof SubscriptionContainer ) || self.subscriptionContainer.isDestroyed() ) {
				self.subscriptionContainer = new SubscriptionContainer( options );
				
				// if it already exists, just update it's options
			} else {
				self.subscriptionContainer.settings( options );
			}
			
			// if the container isn't attached yet, attach it to the DOM
			if ( !self.subscriptionContainer.isAttached() ) {
				channelLayout.request( 'root' ).showChildView( 'main', self.subscriptionContainer );
			}
		}
	},
	
} );

export default SubscriptionController;